import Loading from "@/components/ui/Loading";
import { lazy, Suspense } from "react";
import { ProtectedRoute } from "./ProtectedRoute";
import NotFound from "@/pages/notFound";
import { routeEndpoints } from "./endpoint";

const LandingPage = lazy(() => import("@/pages/landing"));

const DashboardLayout = lazy(() => import("@/layout/DashboardLayout"));
const AnalyticsDashboard = lazy(() => import("@/pages/analyticsDashboard"));
const DeviceDashboard = lazy(() => import("@/pages/deviceDashboard"));
const OperationsDashboard = lazy(() => import("@/pages/operationsDashboard"));
const OperationsEmulatorDetails = lazy(
  () => import("@/pages/operationsDeviceDetails/emulatorDetails"),
);
const OperationsCollectorDetails = lazy(
  () => import("@/pages/operationsDeviceDetails/collectorDetails"),
);
const VehicleDetails = lazy(() => import("@/pages/vehicleDetails"));

export function useLocalRoutes() {
  return [
    {
      path: "/",
      element: (
        <Suspense fallback={<Loading />}>
          <LandingPage />
        </Suspense>
      ),
    },
    {
      element: (
        <Suspense fallback={<Loading />}>
          <ProtectedRoute />
        </Suspense>
      ),
      children: [
        {
          element: (
            <Suspense fallback={<Loading />}>
              <DashboardLayout />
            </Suspense>
          ),
          children: [
            {
              path: routeEndpoints.analyticsDashboard,
              element: (
                <Suspense fallback={<Loading />}>
                  <AnalyticsDashboard />
                </Suspense>
              ),
            },
            {
              path: routeEndpoints.analyticsDeviceDetails,
              element: (
                <Suspense fallback={<Loading />}>
                  <DeviceDashboard />
                </Suspense>
              ),
            },
            {
              path: routeEndpoints.operationsDashboard,
              element: (
                <Suspense fallback={<Loading />}>
                  <OperationsDashboard />
                </Suspense>
              ),
            },
            {
              path: routeEndpoints.operationsEmulatorDetails,
              element: (
                <Suspense fallback={<Loading />}>
                  <OperationsEmulatorDetails />
                </Suspense>
              ),
            },
            {
              path: routeEndpoints.operationsCollectorDetails,
              element: (
                <Suspense fallback={<Loading />}>
                  <OperationsCollectorDetails />
                </Suspense>
              ),
            },
            {
              path: routeEndpoints.vehicleDetails,
              element: (
                <Suspense fallback={<Loading />}>
                  <VehicleDetails />
                </Suspense>
              ),
            },
          ],
        },
      ],
    },
    {
      path: "*",
      element: <NotFound />,
    },
  ];
}
